export default __webpack_public_path__ + "static/media/service-and-maintenance.81d9d854.png";